import { Component, Inject, TemplateRef } from '@angular/core';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { BaseViewComponent } from '@sb/library/base';
import { FormFieldCheckboxMultiSelectComponent } from '@sb/library/form-field';

@Component({
    selector: 'lib-chip-multi-select-bottom-sheet',
    templateUrl: './chip-multi-select-bottom-sheet.component.html',
    styleUrls: ['./chip-multi-select-bottom-sheet.component.scss'],
})
export class ChipMultiSelectBottomSheetComponent<T extends string> extends BaseViewComponent {
    private _currentSelectedItems: Record<number, T[]> = [];

    constructor(private _MatBottomSheetRef: MatBottomSheetRef<ChipMultiSelectBottomSheetComponent<T>>,
        @Inject(MAT_BOTTOM_SHEET_DATA) public data: {
            Options: FormFieldCheckboxMultiSelectComponent<T>[],
            CurrentSelected: Record<number, T[]>,
            Label: TemplateRef<any>
        }) {
        super();

        this._currentSelectedItems = this.data.CurrentSelected;

        this._MatBottomSheetRef.backdropClick().subscribe(_ => {
            this.DismissBottomSheet();
        });
    }

    SelectAll(item: FormFieldCheckboxMultiSelectComponent<T>, mapIndex: number, event: boolean): void {
        item.SelectAll(event);
        this.ChangeEvent(item, mapIndex, event);
    }

    ChangeEvent(item: FormFieldCheckboxMultiSelectComponent<T>, mapIndex: number, event: boolean, itemIndex: number | null = null): void {
        item.ChangeEvent(event, itemIndex);
        this._currentSelectedItems[mapIndex] = item.formControl.value;
    }

    DismissBottomSheet(): void {
        this._MatBottomSheetRef.dismiss(this._currentSelectedItems);
    }
}
